import { api_portalOfficeListingAllType_portalOfficeResponse } from '@/init/swagger';
import useEmblaCarousel from 'embla-carousel-react';
import NoImagePNG from '@/../public/no-image.png';
import AutoScroll from 'embla-carousel-auto-scroll';
import { pagesPath } from '@/lib/$path';

type Args = {
  portalOfficeListings: api_portalOfficeListingAllType_portalOfficeResponse[];
};

export const useLogic = ({ portalOfficeListings }: Args) => {
  const latestPortalOfficeListings = portalOfficeListings
    .map(({ portal_office_listing, portal_office_hospital_listing }) => {
      if (portal_office_listing) {
        return {
          href: pagesPath.public.stations
            ._portalOfficeId(`${portal_office_listing.portal_office_id}`)
            .$url().path,
          image:
            portal_office_listing.portal_office_listing_image?.image1_url ||
            NoImagePNG.src,
          alt:
            portal_office_listing.portal_office_listing_image?.image1 ||
            'NO IMAGE',
          name: portal_office_listing.portal_office?.name,
          appeal: portal_office_listing.appeal,
          portalOfficeId: portal_office_listing.portal_office_id,
        };
      }
      if (portal_office_hospital_listing) {
        return {
          href: pagesPath.public.hospitals
            ._portalOfficeId(
              `${portal_office_hospital_listing.portal_office_id}`,
            )
            .$url().path,
          image:
            portal_office_hospital_listing.portal_office_hospital_listing_image
              ?.image1_url || NoImagePNG.src,
          alt:
            portal_office_hospital_listing.portal_office_hospital_listing_image
              ?.image1 || 'NO IMAGE',
          name: portal_office_hospital_listing.portal_office?.name,
          appeal: portal_office_hospital_listing.appeal,
          portalOfficeId: portal_office_hospital_listing.portal_office_id,
        };
      }
    })
    .filter(
      (
        item,
      ): item is {
        href: string;
        image: string;
        alt: string;
        name: string | undefined;
        appeal: string | undefined;
        portalOfficeId: number | undefined;
      } => item != null,
    );

  const [emblaRef] = useEmblaCarousel({ loop: true }, [
    AutoScroll({
      playOnInit: true,
      speed: 2.5,
      stopOnMouseEnter: false,
      stopOnFocusIn: false,
      stopOnInteraction: false,
      startDelay: 0,
    }),
  ]);

  return {
    latestPortalOfficeListings,
    emblaRef,
  };
};
